import { render, staticRenderFns } from "./UkerportalTalalatpanel.vue?vue&type=template&id=0bbff9c7&"
import script from "./UkerportalTalalatpanel.vue?vue&type=script&lang=js&"
export * from "./UkerportalTalalatpanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports